import { AppContext } from "@/App.context";
import config from "@/config";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import {
  API_LOADING_ERROR,
  API_NOT_FOUND_ERROR,
  ERROR_STATUS_CODES,
  API_NO_DATA_FOUND_ERROR,
} from "@/lib/errors/error-constants";

/**
 * @typedef GetAllStatistics
 * @property {GetAWSStatistics} aws
 * @property {GetAzureStatistics} azure
 */

/**
 * @typedef GetAWSStatistics
 * @property {number} resource_count
 * @property {string} month
 */

/**
 * @typedef GetAzureStatistics
 * @property {number} resource_count
 * @property {string} month
 */

/**
 * @typedef GetAllStatisticsRes
 * @property {GetAllStatistics[]} statistics
 */
/**
 * @typedef GetStatisticsReq
 * @property {'all-cloud'} service
 */

/**
 * @param {GetStatisticsReq} req
 * @returns {Promise<GetAllStatistics>}
 */

export const getRecommStackedStatistics = (token) => {
  return async ({ service }) => {
    const owners = await fetch(
      `${config.apiHost}/v1/${service}/recommendations/allRecommendation`,
      {
        method: "GET",
        headers: {
          Authorization: token,
        },
      }
    );
    if (!owners.ok) {
      if (ERROR_STATUS_CODES.includes(owners.status)) {
        throw new Error(API_LOADING_ERROR);
      }
      if (owners.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR);
      }
      throw new Error((await owners.json()).message);
    }
    const data = await owners.json();
    if (
      data?.aws?.length === 0 &&
      data?.azure?.length === 0 &&
      data?.gcp?.length === 0
    ) {
      throw new Error(API_NO_DATA_FOUND_ERROR);
    }

    return data;
  };
};

/**

 * @param {GetStatisticsReq} req
 * @param {any[]=} deps
 */
export const useRecommStackedData = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getRecommStackedStatistics", req, ...deps],
    queryFn: () => getRecommStackedStatistics(appContext.idToken)(req),
  });
  return query;
};
